export default {
  chatFlow: state => state.chatFlow,
  chatFlowInfos: state => state.chatFlowInfos
}
